import { visionURL } from "../../config/environment";
import Jsona from "jsona";
import JsonApiService from "../../services/jsonapiService";

const dataFormatter = new Jsona();

const usersApiService = async () =>
  new JsonApiService("group_users", {
    baseUrl: `${visionURL}/api`,
    credentials: "include"
  });

export const useGroupUsers = () => {
  return {
    getGroupUsers: async ({
      page,
      pageSize,
      sort,
      filters,
      include = [],
      fields = {},
      custom = {}
    }) => {
      const service = await usersApiService();
      const response = await service
        .page({ number: page, size: pageSize })
        .sort(sort)
        .where(filters)
        .include(include)
        .fields(fields)
        .customParams(custom)
        .all()
        .then(response => response.json());
      return {
        data: dataFormatter.deserialize(response),
        ...response.meta
      };
    }
  };
};
